export default {
    updateOnlineFlag: 'UPDATE_ONLINE_FLAG',
    updatePrevRouter: 'UPDATE_PREV_ROUTER',
}
